const HOUR_IN_MS = 60 * 60 * 1000;
const DAY_IN_MS = 24 * HOUR_IN_MS;

export const isTheSameDay = (first: Date, second: Date): boolean => {
  return (
    Math.abs(first.getTime() - second.getTime()) < DAY_IN_MS &&
    first.getDate() === second.getDate()
  );
};
